import {
  SignUpModalContainer,
  SignUpModalFooter,
  ForgotPasswordContent,
} from "@unauthenticated/signupSignin/components";

const RxSignInForgotPassword = () => {
  return (
    <>
      <SignUpModalContainer>
        <ForgotPasswordContent />
      </SignUpModalContainer>
      <SignUpModalFooter />
    </>
  );
};

export { RxSignInForgotPassword };
